
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Snackbar extends Vue {
  @Prop(String) message!: string;
  @Prop(String) color!: string;
  @Prop({ default: 5000 }) timeout?: number;
  @Prop(String) top?: string;
  @Prop(String) bottom?: string;
  @Prop(String) left?: string;
  @Prop(String) right?: string;

  showSnackbar = false;

  show(): void {
    this.showSnackbar = true;
  }
}
